export const DEFAULT_ROLES = [
    'Site Manager',
    'Project Manager',
    'H&S Officer',
    'Quantity Surveyor',
    'Electrician',
    'Plumber',
    'Carpenter',
    'Groundworker',
    'Traffic Marshal',
    'Labourer',
];
export const DEFAULT_ROLE_REQUIREMENTS = [
    { role: 'Site Manager', mandatory: ['SMSTS', 'First Aid', 'CSCS Black Card'], beneficial: ['IOSH', 'CDM Awareness'] },
    { role: 'Project Manager', mandatory: ['APM PMQ', 'CSCS Black Card', 'First Aid'], beneficial: ['SMSTS', 'CDM Principal Designer'] },
    { role: 'Electrician', mandatory: ['18th Edition', 'CSCS Blue Card', 'ECS Card'], beneficial: ['First Aid', 'Working at Height'] },
    { role: 'H&S Officer', mandatory: ['NEBOSH', 'First Aid', 'CSCS Gold Card'], beneficial: ['IOSH', 'Environmental Awareness'] },
    { role: 'Quantity Surveyor', mandatory: ['CSCS Gold Card', 'RICS Membership'], beneficial: ['NEC Contract', 'APM PMQ'] },
    { role: 'Groundworker', mandatory: ['CSCS Green Card', 'NPORS Excavator'], beneficial: ['First Aid', 'Manual Handling'] },
    { role: 'Traffic Marshal', mandatory: ['CSCS Green Card', 'Traffic Management', 'Banksman'], beneficial: ['First Aid', 'Manual Handling'] },
    { role: 'Plumber', mandatory: ['CSCS Blue Card', 'Gas Safe'], beneficial: ['First Aid', 'BPEC'] },
    { role: 'Carpenter', mandatory: ['CSCS Blue Card'], beneficial: ['First Aid', 'Working at Height'] },
    { role: 'Labourer', mandatory: ['CSCS Green Card'], beneficial: ['First Aid', 'Manual Handling'] },
];
//# sourceMappingURL=roles.js.map